import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Header } from '@rossum/components/header/Header';
import { PageLayout } from '@rossum/components/page-layout/PageLayout';
import { Button } from '@rossum/ui/material';
import { SettingsBreadcrumbs } from '../../../containers/Settings/SettingsBreadcrumbs';
import { InitialCopilot } from '../../rules/copilots/InitialCopilot';
import { RulesList } from '../../rules/rules-list/RulesList';

export const RulesPage = () => {
  const intl = useIntl();
  const history = useHistory();

  const copilotOpen = history.location.hash === '#new';
  const setCopilotOpen = useCallback(
    (open: boolean) => {
      history.replace({ hash: open ? '#new' : '' });
    },
    [history]
  );

  return (
    <PageLayout
      renderHeader={params => (
        <Header
          scrollableDivRef={params.scrollableDivRef}
          breadcrumbs={
            <SettingsBreadcrumbs
              breadcrumbs={[
                {
                  label: intl.formatMessage({
                    id: 'features.ruleManager.list.title',
                  }),
                },
              ]}
            />
          }
          beta
          buttons={[
            <Button
              key="create-rule"
              variant="contained"
              onClick={() => setCopilotOpen(true)}
              data-cy="add-rule-button"
              sx={{
                '&:hover': {
                  color: 'inherit',
                },
              }}
            >
              {intl.formatMessage({
                id: 'features.queueSettings.rules.list.addRule',
              })}
            </Button>,
          ]}
          title={intl.formatMessage({
            id: 'features.ruleManager.list.title',
          })}
          description={intl.formatMessage({
            id: 'features.ruleManager.list.description',
          })}
        />
      )}
    >
      <RulesList onCreateRule={() => setCopilotOpen(true)} />
      <InitialCopilot
        allowQueueChange
        onSuccess={value => {
          setCopilotOpen(false);
          history.push({
            pathname: '/settings/rule-manager/new',
            state: { rule: value },
          });
        }}
        onClose={() => setCopilotOpen(false)}
        open={copilotOpen}
      />
    </PageLayout>
  );
};
